import { FileUploadStatus, FileWithStatus } from '@/types/upload';

const WARNING_FAILURE_CODES = new Set<string>([FileUploadStatus.FILENAME_MISMATCH, FileUploadStatus.ALREADY_EXISTS]);

const STATUS_TEXT: Partial<Record<FileUploadStatus, string>> = {
  [FileUploadStatus.COMPLETED]: 'Uploaded',
  [FileUploadStatus.FAILED]: 'Failed',
  [FileUploadStatus.UPLOADING]: 'Uploading',
};

export const isDuplicateUploadFailure = (file: FileWithStatus): boolean =>
  file.status.code === FileUploadStatus.ALREADY_EXISTS;

export const isWarningUploadFailure = (file: FileWithStatus): boolean =>
  file.status.state === FileUploadStatus.FAILED && WARNING_FAILURE_CODES.has(String(file.status.code));

export const isErrorUploadFailure = (file: FileWithStatus): boolean =>
  file.status.state === FileUploadStatus.FAILED && !isWarningUploadFailure(file);

export const getFileStatusText = (file: FileWithStatus): string => {
  if (isDuplicateUploadFailure(file)) {
    return 'Already exists';
  }
  return STATUS_TEXT[file.status.state] ?? 'Pending';
};
